import React, { ReactElement, ReactNode, useCallback } from 'react'

import { Color } from '../../../../enums/color'
import { Text } from '../../../Text'
import * as Styled from './styles'

export interface BreadcrumbItemProps<T = string> {
  id: string
  children: ReactNode
  value: T
  onClick?: (value: T, id: string) => void
  current?: boolean
}
export const BreadcrumbItem = ({ children, onClick, id, value, current }: BreadcrumbItemProps): ReactElement => {
  const handleOnClick = useCallback(() => {
    onClick && onClick(value, id)
  }, [onClick, value, id])

  return (
    <Styled.BreadcrumbItemWrapper onClick={handleOnClick} clickable={!!onClick}>
      <Text color={current ? Color.Grey300 : Color.Grey500} variant="bodySM" weight="regular">
        {children}
      </Text>
    </Styled.BreadcrumbItemWrapper>
  )
}
